import React from "react";
import {
  TextColumnConfig,
  EmailColumnConfig,
  NumberColumnConfig,
  DateColumnConfig,
  DateTimeColumnConfig,
  CurrencyColumnConfig,
  DropDownColumnConfig,
  FileColumnConfig,
  CodeSnippetColumnConfig,
  ExpressionFormulaColumnConfig,
  LookupColumnConfig,
  SubsheetColumnConfig,
  PercentageColumnConfig,
  UrlColumnConfig
} from "./Columns";
export default function Factory(props) {
  const Component = getComponent(props.values?.column_type_id);

  return Component && <Component {...props} />;
}

function getComponent(columnTypeId) {
  switch (parseInt(columnTypeId)) {
    case 1:
    case 20:
      return TextColumnConfig;
    case 24:
      return UrlColumnConfig;
    case 14:
      return EmailColumnConfig;
    case 22:
      return PercentageColumnConfig;
    case 5:
      return NumberColumnConfig;
    case 17:
      return CurrencyColumnConfig;
    case 4:
      return DateColumnConfig;
    case 16:
      return DateTimeColumnConfig;
    case 3:
    case 13:
    case 11:
      return DropDownColumnConfig;
    case 9:
      return FileColumnConfig;
    case 7:
      return CodeSnippetColumnConfig;
    case 19:
      return ExpressionFormulaColumnConfig;
    case 10:
      return LookupColumnConfig;
    case 6:
      return SubsheetColumnConfig;
    case 8:
    default:
      return null;
  }
}
